import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthCallback({ onAuthSuccess }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error("No session_id found in URL");
        navigate("/", { replace: true });
        return;
      }
      
      const sessionId = sessionIdMatch[1];
      
      try {
        // Exchange session_id for user data
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        
        const userData = response.data.user;
        
        // Store user in localStorage for quick access
        localStorage.setItem("shots_user", JSON.stringify(userData));
        
        // Notify parent and navigate
        if (onAuthSuccess) {
          onAuthSuccess(userData);
        }
        
        // Clear the hash and navigate to main app
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true, state: { user: userData } });
        
      } catch (error) {
        console.error("Auth error:", error);
        localStorage.removeItem("shots_user");
        navigate("/", { replace: true });
      }
    };
    
    processAuth();
  }, [navigate, onAuthSuccess]);

  // Show minimal loading state
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-[#262626] border-t-[#BEF264] rounded-full animate-spin mx-auto mb-4" />
        <p className="font-mono text-[11px] text-[#737373] tracking-wider uppercase">
          Autenticando...
        </p>
      </div>
    </div>
  );
}

export function useAuth() {
  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.error("Logout error:", error);
    }
    localStorage.removeItem("shots_user");
  };

  return { checkAuth, login, logout };
}
